<template>
  <div v-scroll.stop="handleScroll">     
    <header id="header">
      <b-navbar toggleable="sm" type="dark" variant="light" fixed="top" :class="'main-nav'">
            <b-navbar-brand></b-navbar-brand>
            <img src="../img/logo.png" class="logoMaria">
            <div class="btn-prematricula">
              <b-button
                v-show="true"
                type="submit"
                @click="openSignup"
                variant="primary"
              >Pré-Matrícula</b-button>
            </div>
            <b-navbar-toggle target="nav-collapse" style="border: solid 1px black"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav class="navitems">
              <!--<b-navbar-nav>
                <b-nav-item class="ativado">MARIA BAILARINA</b-nav-item>
              </b-navbar-nav>-->
              <!-- Right aligned nav items -->
              <!-- :class="'active'" -->
              <b-navbar-nav class="ml-auto">
                <b-nav-item id="lkhome" :class="homeSel" @click="scrollToElement">Home</b-nav-item>
                <b-nav-item id="lksobre" :class="sobreSel" @click="scrollToElement">Sobre</b-nav-item>
                <b-nav-item id="lktrabalho" :class="trabalhoSel" @click="scrollToElement">Serviços</b-nav-item>
                <b-nav-item id="lkequipe" :class="equipeSel" @click="scrollToElement">Coordenação</b-nav-item>
                <b-nav-item id="lkcontato" :class="contatoSel" @click="scrollToElement">Contato</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
      </b-navbar>
    </header>
    <main class="principal">
      <!--<div id="nenhum" class="row"></div>-->
      <div class="container-fluid">
        <section id="home" class="section is-primary is-fullheight">
            <home ref="home" @openCadastro="abrirCadastro"></home>
        </section>
        <section id="sobre" class="section hero is-primary is-fullheight">
          <b-container fluid>
            <sobre v-show="animateCtrl.sobre" ref="sobre"></sobre>
          </b-container>
        </section>
        <section id="trabalho" class="section hero is-primary is-fullheight">
            <servico v-show="animateCtrl.trabalho" ref="trabalho"></servico>
        </section>
        <section id="equipe" class="section hero is-primary is-fullheight">
          <b-container fluid>
            <meu-time v-show="animateCtrl.equipe" ref="equipe"></meu-time>
          </b-container>
        </section>
      </div>
    </main>

    <footer id="footer" class="section-bg">
      <section id="contato" class="section hero credentials is-primary is-fullheight">
        <b-container fluid>
          <contato></contato>
        </b-container>
      </section>
      <div class="copyright">
            &copy; Copyright <strong>Maria Bailarina</strong>. Todos os Direitos Reservados
          </div>
          <div class="credits">
            Desenvolvido por Smartise
          </div>
    </footer>

    <b-modal
      size="lg"
      scrollable
      centered
      hide-footer
      v-model="modalCad"
      @close="modalCad=false"
      :no-close-on-backdrop="true"
      id="modal-1"
      title="Cadastro de Bailarina(o)"
    >
      <cadastro v-show="modalCad"></cadastro>
    </b-modal>
    <accept />
    <!-- <div v-scroll="handleScroll" v-if="mostrarScroll"></div> -->
  </div>
</template>

<script>
import Accept from "./accept.vue";
import Cadastro from "./cadastro.vue";
import Contato from "./contato.vue";
import Home from "./home.vue";
import MeuTime from "./meutime.vue";
import Servico from "./servico.vue";
import Sobre from "./sobre.vue";

const delay = () => {
  console.log('start delay')
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('stop delay')
      resolve()
    }, 500);
  })
}

export default {
  name: "Main",
  components: {
    Home,
    Sobre,
    Servico,
    MeuTime,
    Contato,
    Cadastro,
    Accept
  },
  data() {
    return {
      mostrarScroll: true,
      modalCad: false,
      homeSel: 'active',
      sobreSel: '',
      equipeSel: '',
      contatoSel: '',
      trabalhoSel: '',
      click: null,
      animateCtrl: {
        home: false,
        sobre: false,
        trabalho: false,
        equipe: false
      },
      scrollTimeout: null,
    };
  },
  mounted() {
    this.click = null
    this.animateCtrl = {
        home: false,
        sobre: false,
        trabalho: false,
        equipe: false,
    };
    // if (this.$refs.home && this.$refs.home.animationElement) this.$refs.home.animationElement(0, false)
    if (this.$refs.sobre && this.$refs.sobre.animationElement) this.$refs.sobre.animationElement(0, false)
    if (this.$refs.trabalho && this.$refs.trabalho.animationElement) this.$refs.trabalho.animationElement(0, false)
    if (this.$refs.equipe && this.$refs.equipe.animationElement) this.$refs.equipe.animationElement(0, false)
  },
  created: function() {
    
  },
  beforeDestroy() {},
  methods: {
    openSignup() {
      this.modalCad = !this.modalCad
    },

    abrirCadastro() {
      this.modalCad = false
      this.modalCad = true
    },
 
    scrollToElement(el) {
      let yOffset = 0

      
      let elemento = null
      // let opt = el.target.innerHTML
      let opt = null

      const listItem = el.target.closest("li");
      if (listItem && listItem.id) {
        let elementId = listItem.id;
        opt = elementId.replace("lk", "");
        //const targetElement = document.getElementById();
        // if (targetElement) {
          //   targetElement.scrollIntoView({ behavior: "smooth" });
          // }
      }
        
      let resMicMob = window.matchMedia("(max-width: 500px)").matches
      let resMedMob = (window.matchMedia("(min-width: 501px)").matches && window.matchMedia("(max-width: 770px)").matches)
      let resBigMob = (window.matchMedia("(min-width: 771px)").matches && window.matchMedia("(max-width: 999px)").matches)
      let resExtMob = window.matchMedia("(min-width: 1000px)").matches
      
      //console.log(resMicMob, resMedMob, resBigMob, resExtMob);
      this.click = opt
      switch (opt) {
        case 'home':
          elemento = document.getElementById("home")
          yOffset = -30
          break;

        case 'sobre':
          // elemento = this.$el.querySelector("#sobre")
          elemento = document.getElementById("sobre")
          yOffset = 0
          break;

        case 'trabalho':
          elemento = document.getElementById("trabalho")
          yOffset = 0
          break;

        case 'equipe':
          elemento = document.getElementById("equipe")
          yOffset = -50
          if (resMicMob) yOffset = -10
          if (resMedMob) yOffset = -10
          if (resBigMob) yOffset = -200
          if (resExtMob) yOffset = -120
          break;

        case 'contato':
          elemento = document.getElementById("contato")
          if (resMicMob) {
            yOffset = -120
          } else if (resMedMob) {
            yOffset = -120
          } else if (resBigMob) {
            yOffset = -120
          } else {
            yOffset = -120
          }
          break;
      
        default:
          break;
      }

      if (elemento) {
        const y = elemento.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({top: y, behavior: 'smooth'});
      }

    },
    
    handleScroll() {

      let resMobile = window.matchMedia("(max-width: 900px)")
      let elHome = document.querySelector('#home')
      let elSobre = document.querySelector('#sobre')
      let elTrabalho = document.querySelector('#trabalho')
      let elEquipe = document.querySelector('#equipe')
      let elContato = document.querySelector('#contato')
      let posHome = elHome.getBoundingClientRect().top
      let posSobre = elSobre.getBoundingClientRect().top
      let posTrabalho = elTrabalho.getBoundingClientRect().top
      let posEquipe = elEquipe.getBoundingClientRect().top
      let posContato = elContato.getBoundingClientRect().top
      let objPos = {
        home: posHome,
        h_home: elHome.scrollHeight,
        sobre: posSobre,
        h_sobre: elSobre.scrollHeight,
        trabalho: posTrabalho,
        h_trabalho: elTrabalho.scrollHeight,
        equipe: posEquipe,
        h_equipe: elEquipe.scrollHeight,
        contato: posContato,
        h_contato: elContato.scrollHeight,
        mobile: resMobile
      }

      //console.log('pos serv', objPos.servicos, 'window', window.pageYOffset);

      this.posNow = objPos[this.click]

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout); // Reseta o timer se o scroll continuar
      }

      this.scrollTimeout = setTimeout(() => {
        this.click = null;
      }, 300);

      this.setActiveLink(objPos)
      if (this.click === null) {
        this.setAnimationRolagem(objPos)
      } else {
        this.setAnimationClick(objPos)
      }

      // console.log('scroll', window.scrollY)

      // this.posPrev = window.scrollY

    },

    checkScrollPosition() {
      const target = document.getElementById('target');
      const targetPosition = target.getBoundingClientRect().top;

      if (targetPosition <= window.innerHeight && targetPosition >= 0) {
        console.log('Scroll alcançou a posição desejada!');
      }
    },

    setActiveLink(objPos) {
      if (objPos.home > -(objPos.h_home/2) && objPos.home < 250) {
        this.resetActiveLink()
        this.homeSel = 'active'
      } 

      if (objPos.sobre > -(objPos.h_sobre/2)  && objPos.sobre < 250) {
        this.resetActiveLink()
        this.sobreSel = 'active'
      }
      
      if (objPos.servicos > -(objPos.h_servicos/2) && objPos.servicos < 250) {
        this.resetActiveLink()
        this.trabalhoSel = 'active'  
      }
      if (objPos.equipe > -(objPos.h_equipe/2) && objPos.equipe < 250) {
        this.resetActiveLink()
        this.equipeSel = 'active'
      }
      if (objPos.contato > -200 && objPos.contato < 250) {
        this.resetActiveLink()
        this.contatoSel = 'active'
      }
    },

    resetActiveLink() {
      this.homeSel = ''
      this.sobreSel = ''
      this.trabalhoSel = ''
      this.equipeSel = ''
      this.contatoSel = ''
    },

    setAnimationRolagem(objPos) {
      // let isMobile = objPos.mobile.matches
      const viewportHeight = window.innerHeight;
      const deal = viewportHeight / 2
      const min = (viewportHeight / 3)*-1
      if (objPos.sobre >= min && objPos.sobre <= deal && !this.animateCtrl.sobre) {
        this.animateCtrl.sobre = true;
        if (this.$refs.sobre && this.$refs.sobre.animationElement) this.$refs.sobre.animationElement(objPos.sobre, true)
      }

      if (objPos.trabalho >= min && objPos.trabalho <= deal && !this.animateCtrl.trabalho) {
        this.animateCtrl.trabalho = true;
        if (this.$refs.trabalho && this.$refs.trabalho.animationElement) this.$refs.trabalho.animationElement(objPos.trabalho, true)
      }

      if (objPos.equipe >= min && objPos.equipe <= deal && !this.animateCtrl.equipe) {
        this.animateCtrl.equipe = true;
        if (this.$refs.equipe && this.$refs.equipe.animationElement) this.$refs.equipe.animationElement(objPos.equipe, true)
      }
    },

    setAnimationClick(objPos) {
      const viewportHeight = window.innerHeight;
      const deal = viewportHeight / 2
      const min = (viewportHeight / 2)*-1
      // console.log('pos sobre:', objPos.sobre, min, deal)
      if (objPos.sobre <= deal && !this.animateCtrl.sobre && this.click === 'sobre') {
        this.animateCtrl.sobre = true;
        if (this.$refs.sobre && this.$refs.sobre.animationElement) this.$refs.sobre.animationElement(objPos.sobre, true)
      }

      if (objPos.trabalho <= deal && !this.animateCtrl.trabalho && this.click === 'trabalho') {
        this.animateCtrl.trabalho = true;
        if (this.$refs.trabalho && this.$refs.trabalho.animationElement) this.$refs.trabalho.animationElement(objPos.trabalho, true)
      }

      if (objPos.equipe <= deal && !this.animateCtrl.equipe && !this.animateCtrl.equipe &&this.click === 'equipe') {
        this.animateCtrl.equipe = true;
        if (this.$refs.equipe && this.$refs.equipe.animationElement) this.$refs.equipe.animationElement(objPos.equipe, true)
      }
    }
  }
};

</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #444;
  /*margin-top: 60px; */
  background-color: #ffffff !important;
  max-width: 100vw !important;
  margin: 0px;
}

html, body {
    overflow-x: hidden;
}

main {
  display: block;
}

#modal-1 .modal-header {
  height: 60px !important;
}

.container-fluid {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

a {
  color: #ff58a5 !important;
  transition: 0.5s;
}
.colmain {
  margin: 0px;
  padding: 0px;
}

.main-pages {
  margin-top: 60px;
}

.navbar {
  background-color: #974548 !important;
  margin: 0;
  padding: 10px;
}

.navitems > ul > li > a {
  font-weight: bold;
}

#header .btn-primary {
    color: #fff;
    background-color: #ff58a5b0;
    border-color: #ff58a5b0;
}

#header .btn-primary:hover {
    color: #fff;
    background-color: #da3c86e5;
    border-color: #da3c86e5;
}

/*.btn-primary:focus */
#header .btn-primary.focus, .btn-primary:active {
  -webkit-box-shadow: 0 0 0 0.2rem #bb477de5;
  box-shadow: 0 0 0 0.2rem #bb477de5;
}

/*a:focus*/
a:hover,
a:active {
  color: #f6a0c8 !important;
  outline: none;
  text-decoration: none;
}

.navbar-nav a:hover,
.navbar-nav .active > a,
.navbar-nav li:hover > a {
  color: #f6a0c8 !important;
  text-decoration: none;
}

.main-nav {
  padding: 10px 35px 10px 35px;
}

/*
.main {
  padding-top: 100px !important;
}

.hero.is-fullheight {
  min-height: 100vh;
}
.hero.is-primary {
  background-color: #00d1b2;
  color: #fff;
}
.section {
  background-color: #fff;
} */
/*main {
  margin-top: 0px;
  max-width: 100vw !important;
  /*min-width: 100vw; 
  min-height: 100vh;
  margin: 0px;
} */



.hero {
  min-height: 100vh;
  padding: 0px 50px 0px 50px;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  background-color: #ffffff !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.hero.credentials {
  min-height: 60vh !important;
}

#footer {
  padding: 0 0 30px 0;
  font-size: 14px;
  background: #fff;
  min-height: 850px;
}

/*.whatsapp {
  position: fixed;
  right: 15px;
  bottom: 60px;
  transition: background 0.5s;
  z-index: 10000000;
  max-width: 100px;
  max-height: 50px;
}*/

.navbar-dark .navbar-brand {
    color: #fff;
    display: none;
}

.btn-prematricula {
  min-width: 300px;
}


.logoMaria {
  max-height: 50px;
}

@media screen and (max-width: 767px) {
  main {
    margin-top: 0px;
    max-width: 100vw !important;
    min-width: 100vw; 
    min-height: 100vh;
    margin: 0px;
  }
}

@media screen and (max-width: 767px) {
  .hero {
    padding: 0px 15px 0px 15px;
  }

  .logoMaria {
    max-height: 45px;
  }

  .btn-prematricula {
    min-width: 120px;
  }

}


</style>



// WEBPACK FOOTER //
// src/views/main.vue